export default __webpack_public_path__ + "static/media/dots.b26a595f.svg";